import React from 'react';
import {
  Container,
  Col,
  Row,
  Div,
} from '../../components/grid';
import {
  Heading1,
  Paragraph,
  LinkStyled,
  Bold,
} from '../../components/typography';
import { Price } from '../../containers/commerce';
import SidemenuLayout from '../../layout/DefaultLayout/Layouts/SidemenuLayout';

export default () => (
  <SidemenuLayout menuPicker="Infosider" activeSidemenu="FAQ">
    <Container white itemscope itemprop="mainEntity" itemtype="https://schema.org/Question">
      <Row block>
        <Col xs={12}>
          <Row m0 innerShadow>
            <Col xs={12} padding="40px 15px" grey>
              <Row>
                <Col xs={12} md={6} offset={{ md: 3 }}>
                  <Heading1 fontSize="18px" itemprop="name">Langtidsudlån - Jeg skal holde 2 fester. Hvad er konditionerne?</Heading1>
                  <hr />
                  <Paragraph>
                    Langtidsudlån. Jeg købte øl og lejede anlæg hos jer med stor succes til en privat oktoberfest sidste år.
                  </Paragraph>
                  <Paragraph>
                    Nu er det blevet til en privat fest (20/10) og 2 uger senere (3/11) en vejfest med samme tema.
                    Hvad er konditionerne hvis jeg skal beholde anlæg og fustager fra f.eks. den 17. oktober til aflevering den 5. november?
                  </Paragraph>
                  <hr />
                  <Paragraph>
                    <Bold>Svar:</Bold>
                  </Paragraph>
                  <Div itemscope itemprop="acceptedAnswer" itemtype="https://schema.org/Answer">
                    <Paragraph>På denne tid af året hvor vi ikke har lejet alt tappeudstyr ud, kan du nemt beholde anlæg og fustager fra den ene fest til den anden. </Paragraph>
                    <Paragraph>Da der er under 1 måned mellem festerne er det ikke nødvendigt med gennemskylning og rensning af fadølsanlægget.</Paragraph>
                    <Paragraph>Vi opkræver 2 x leje af <Price varenr="3617" /> fordi der er 2 fester, men ingen leje i perioden mellem arrangementerne.</Paragraph>
                    <Paragraph>Du sparer således kørslen til fest nummer 2.</Paragraph>
                  </Div>

                  <hr />
                  <Paragraph textCenter>
                    <LinkStyled to="/faq/faq" title="Tilbage til FAQ oversigt">
                      Tilbage til FAQ oversigt
                    </LinkStyled>
                  </Paragraph>
                </Col>
              </Row>
            </Col>
          </Row>
        </Col>
      </Row>
    </Container>
  </SidemenuLayout>
);
